import React, { useEffect, useState } from "react";
import { Tabs, Col, Row, Spin } from "antd";
import { BarsOutlined } from "@ant-design/icons";
import CashFlowMonthlyReport from "./CashFlowMonthlyReport";
import CashFlowDailyReport from "./CashFlowDailyReport";
import CashFlowNotAuthorize from "../NotFound/CashFlowNotAuthorize"; // 403 componentini import et
import RequestHandler from "../../util/RequestHandler";

const CashFlowReport = () => {
  const [hasPermission, setHasPermission] = useState(null); // null = loading, true/false
  const [activeKey, setActiveKey] = useState("1");

  useEffect(() => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        if (response?.isUseCashFlowReport) {
          setHasPermission(true);
        } else {
          setHasPermission(false);
        }
      } else {
        setHasPermission(false);
      }
    });
  }, []);

  // 1️⃣ Loading durumu
  if (hasPermission === null) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin tip="Yükleniyor..." />
      </div>
    );
  }

  // 2️⃣ Yetkisi yoksa 403 componentini göster
  if (!hasPermission) {
    return <CashFlowNotAuthorize />;
  }

  // 3️⃣ Yetkisi varsa normal tablar
  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> NAKİT AKIŞ RAPORU
          </p>
        </Col>
      </Row>

      <Tabs activeKey={activeKey} onChange={setActiveKey}>
        <Tabs.TabPane tab="Ay Bazlı" key="1">
          <CashFlowMonthlyReport />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Gün Bazlı" key="2">
          <CashFlowDailyReport />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};

export default CashFlowReport;
